import { useGraphQLQuery } from '@betterment/graphql';
import { Card, H2 } from '@betterment/samba-react';

import { ErrorBoundary } from '~/b4b/components/error-boundary/ErrorBoundary';
import { useCurrentEmployerId } from '~/b4b/utils/currentEmployer';

import { EmployerSupportDocument } from './graphql/query.getSupportContacts.generated';
import { ErrorSupportCard } from './support-card/ErrorSupportCard';
import { SupportContacts } from './support-card/SupportContacts';

import type { SupportContact } from '~/graphql/schema';

const GetSupportCardQuery = () => {
  const employerId = useCurrentEmployerId();
  const { data } = useGraphQLQuery(EmployerSupportDocument, {
    variables: { employerId },
    throwOnError: true,
  });
  return <SupportContacts contacts={data?.employer?.support?.contacts as SupportContact[] | undefined} />;
};

export const GetSupportCard = () => (
  <Card css={{ p: 'space.300' }}>
    <Card.Header css={{ marginBottom: 'space.300' }}>
      <H2 variant="title200">Get support</H2>
    </Card.Header>
    <Card.Content>
      <ErrorBoundary name="supportCard" renderFallback={ErrorSupportCard}>
        <GetSupportCardQuery />
      </ErrorBoundary>
    </Card.Content>
  </Card>
);
